import { OptionListItem } from "../components/ProductOption/ProductOption";
import { dedupeOptionListItems } from "./dedupeOptionsList";

export type GroupedOptionListItem = {
  category: {
    name: string;
    _id: string;
  };
  items: OptionListItem[];
};

export const groupByCategory = (optionItems?: OptionListItem[]) => {
  const uniqueItems = dedupeOptionListItems(optionItems);

  // First, sort items by their SubCategory's sortOrder
  const sortedItems = [...uniqueItems].sort((a, b) => {
    const sortA = a?.SubCategory?.sortOrder ?? 0;
    const sortB = b?.SubCategory?.sortOrder ?? 0;
    return sortA - sortB;
  });

  return sortedItems.reduce((pv, cv) => {
    const current = pv.findIndex(
      (i) =>
        i?.category &&
        cv?.SubCategory?.Category &&
        i.category?._id === cv.SubCategory.Category?._id
    );
    if (current !== -1) {
      pv[current].items.push(cv);
    } else {
      const cat = cv.SubCategory?.Category;
      if (cat) {
        pv.push({
          category: cat,
          items: [cv],
        });
      }
    }
    return pv;
  }, [] as GroupedOptionListItem[]);
};
